import { Link } from "react-router-dom";
import Logo from "../assets/logo.png"

export const scrollToForm = () => {
  const el = document.getElementById("founding-form");
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -40, duration: 1.6 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export default function SiteNav() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b hairline bg-[#17151B]/70 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/home" data-testid="nav-brand" className="flex items-baseline gap-1 group">
          <div className="flex items-center">
            <img src={Logo} alt="femipalLogo" className="w-[40px]" />
            <span className="font-serif-display text-2xl font-semibold tracking-tight text-[#F7F3FA]">
              Femipal
            </span>
          </div>
        </Link>
        <nav className="flex items-center gap-6 md:gap-8">
          <button
            onClick={scrollToForm}
            data-testid="nav-join-button"
            className="overline-label bg-[#F3698F] text-white px-5 py-2.5 rounded-full hover:bg-[#E55C7E] transition-colors duration-300"
          >
            Join Founding 100
          </button>
        </nav>
      </div>
    </header>
  );
}